import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { Form, Select, DatePicker } from 'tea-component';
import { useForm, useField } from 'react-final-form-hooks';
import './index.scss';
import { useDeepCompareEffect } from 'ahooks';
import RangePicker from '@/pages/home/components/RangePicker';
const { MonthPicker, QuarterPicker } = DatePicker;
const componentData = {
  RangePicker,
  Select,
  MonthPicker,
};
function MyComponent({ component, config }) {
  // 确保传递的是组件的引用或字符串形式的组件名
  const Component = componentData[component]; // 可以是 MyComponent 或 'MyComponent'
  return React.createElement(Component, config); // 或者 <Component /> 在 JSX 中
}
function TableContent(props: any, ref: any) {
  const { layout = 'inline', hideLabel = false, formControl, formList } = props;
  // 获取所有数据
  const getFormList = () => {
    const formInitData: any = {};
    formList.map((item: any) => {
      formInitData[item.key] = item.defaultValue || '';
    });
    return formInitData;
  };

  // 表单初始化
  const [formValues, setFromValues] = useState(getFormList());
  useDeepCompareEffect(() => {
    setFromValues(getFormList());
  }, [formList]);

  const { form, handleSubmit, validating, submitting } = useForm({
    onSubmit,
    /**
     * 默认为 shallowEqual
     * 如果初始值有多层，会导致重渲染，也可以使用 `useEffect` 设置初始值：
     * useEffect(() => form.initialize({ }), []);
     */
    // initialValuesEqual: () => true,
    initialValues: formValues, // 把相关字段，塞入表单
    validate: ((data: any) => {
      const validateData = {};
      formList.map((item: any) => {
        if (item?.validator) {
          validateData[item.key] = item.validator(data[item.key]);
        }
      });
      return validateData;
    }),
  });
  // 初始化表单验证信息
  const validateList = {};
  formList.map((item: any) => {
    validateList[item.key] = item.key && useField(item.key, form);
  });


  function onSubmit(values: Object) {
    // values 表单相关值(用户输入的字段formValues)
  }


  // 可用于数据回显的方法
  useEffect(() => form.initialize(formValues), [form, formValues]);

  // 获取目标字段用户输入值状态，是否符合报错条件
  const getStatus = useCallback((meta: any, validating: Boolean) => {
    if (meta?.active && validating) {
      return 'validating';
    }
    if (!meta?.touched) {
      return;
    }
    return meta?.error ? 'error' : 'success';
  }, []);

  // // 是否首次执行
  // useEffect(() => {
  //   // immediately
  //   if (immediately) getAllData();
  // }, []);

  // useImperativeHandle(ref, () => ({
  //   search: () => getAllData, // 暴露 搜索方法
  // }));
  return (
    <>
      <Form layout={layout} key='TableForm' hideLabel={hideLabel} {...formControl} className="dbs-table-form" onSubmit={handleSubmit}>
        {formList.filter((item: any) => !item?.hidden).map((item: any) => {
          // Destructure non-Form.Item props to prevent them from being passed to the underlying div
          const { render, type, componentConfig, hidden, defaultValue, validator, ...formItemProps } = item;
          return (
            <Form.Item {...formItemProps} key={item?.key}
              status={getStatus(validateList[item.key]?.meta, validating)}
              message={(getStatus(validateList[item.key]?.meta, validating) === 'error' && validateList[item.key]?.meta.error)}>
              {/* {item?.type === 'MonthPicker' &&  <Select
                  appearance="button"
                  options={[{ value: "Month", text: "Month" },]}
                  value={'Month'}
                  onChange={value => ''}
                  placeholder="请选择你最爱的水果"
                />} */}
              {type && <MyComponent component={type} config={componentConfig} />}
              {render && render()}
            </Form.Item>
          );
        })}
      </Form>
    </>
  );
}
export default forwardRef(TableContent);
